import { BlogPostEditor } from './components/Editor'
import { DriveFileListCards as BlogPostListCards } from './components/ListCards'
import { Thumbnail } from './components/Thumbnail'
import { BlogPostProvider } from './context'
import { useDriveFile } from './hooks/useDriveFile'

export const FeatureBlogPostClient = {
  List: BlogPostListCards,
  Editor: BlogPostEditor,
  Thumbnail: Thumbnail,
  useById: useDriveFile,
  Provider: BlogPostProvider,
}
